import { colors } from '@styles/colors'
import { borderRadius, flexCenter } from '@styles/utils'
import { padding } from 'polished'
import React, { useMemo } from 'react'
import { LabelS } from '../base-typography'

interface InquiryStatusTagProps {
  isAnswered: boolean
  isAdmin?: boolean
}

export const InquiryStatusTag = React.memo(
  ({ isAnswered, isAdmin }: InquiryStatusTagProps) => {
    const { label, color, backgroundColor } = useMemo(
      () =>
        isAnswered
          ? {
              label: '답변완료',
              color: colors.green400,
              backgroundColor: colors.green50,
            }
          : isAdmin
          ? {
              label: '답변대기',
              color: colors.orange400,
              backgroundColor: colors.orange50,
            }
          : {
              label: '처리중',
              color: colors.orange400,
              backgroundColor: colors.yellow100,
            },
      [isAdmin, isAnswered]
    )

    return (
      <LabelS
        color={color}
        $style={{
          ...flexCenter,
          backgroundColor,
          display: 'inline-flex',
          ...padding('4px', '8px'),
          ...borderRadius(8),
          minWidth: '48px',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </LabelS>
    )
  }
)
